import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const PaymentGatewayLogo = ({ gatewayName, doneFromWallet }) => {
  const logos = {
    WALLET: toAbsoluteUrl('media/payment-logos/wallet.png'),
    PAYPAL: toAbsoluteUrl('media/payment-logos/paypal.png'),
    STRIPE: toAbsoluteUrl('media/payment-logos/stripe.png'),
    OFFLINE: toAbsoluteUrl('media/payment-logos/offline.png'),
    PLAIDDWOLLA: toAbsoluteUrl('media/payment-logos/dwolla.png'),
    ACH: toAbsoluteUrl('media/payment-logos/ach.png'),
    MANGOPAY: toAbsoluteUrl('media/payment-logos/mangopay.png'),
    POL: toAbsoluteUrl('media/payment-logos/polygon.png'),
    ETH: toAbsoluteUrl('media/payment-logos/ethereum.png'),
  };

  const getLogo = (name) => {
    if (!name) return null;

    const normalizedKey = name.toUpperCase().replace(/[-_\s]/g, "");

    return logos[normalizedKey] ?? null;
  };
  if (doneFromWallet === "full") {
    return <img src={getLogo("WALLET")} height={19} alt="Wallet" />;
  }

  if (doneFromWallet === "partial") {
    return (
      <div className="d-flex align-itmes-center gap-1">
        <img src={getLogo("WALLET")} height={19} alt="Wallet" />
        <span>+</span>
        {gatewayName && (
          <img src={getLogo(gatewayName)} height={19} alt={gatewayName} />
        )}
      </div>
    );
  }

  const logo = getLogo(gatewayName);
  return logo ? <img src={logo} alt={gatewayName} height={19} /> : "-";
};

export default PaymentGatewayLogo;
